export class Controller {

    /** @ngInject */
    constructor($state, Alert, DirectoriesResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.keepAccounts = true;
    }

    deleteDomain() {
        this.isSaving = true;
        this.DirectoriesResource
            .deleteDomain(this.companyId, this.directory.id, this.domain.id, this.keepAccounts)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.directory-integration.manage.domains.delete-domain.deleted'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/delete-domain/delete-domain.controller.js